import { Component, OnInit,Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationEvaluateService } from 'src/app/Service/Calibration/CalibrationEvaluate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CalibrationEvaluateForm',
  templateUrl: './CalibrationEvaluateForm.component.html',
  styleUrls: ['./CalibrationEvaluateForm.component.scss']
})
export class CalibrationEvaluateFormComponent implements OnInit {

  Token: String = ""
  @Input() inner_Evaluate:General_Interface=Empty_General_Interface()

  constructor(
    private Evaluate_Service:CalibrationEvaluateService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.FormEvaluate=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })

    this.get_Form_Title().setValue(this.inner_Evaluate.title)

    this.Nav_Service.CheckValidPage(this.Token,1156).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  FormEvaluate:FormGroup;

  get_Form_Title(){
    return this.FormEvaluate.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitFormEvaluate(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=this.inner_Evaluate.id
    Record.title=this.get_Form_Title().value

    this.InProccessing=true
    this.Evaluate_Service.AddEditCalibrationEvaluate(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else if(data.id==-1){
          this.Alertify_Service.ErrorMessage("No more than 10 active questions can be registered.")
        }
        else {
          this.inner_Evaluate.id=data.id
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
